import { useContext, useState, useEffect } from "react"
import _ from "lodash"
import { Field } from "formik"
import { FormContext } from "../../../context/formContext"
import { InputMask as Input } from "primereact/inputmask"
import { InputText } from "primereact/inputtext"
import fieldVisibility from "../../../helpers/fieldVisibility"
import { TRIM_TYPES, trimTextValue } from "../helpers/trimTextValue"
import styles from "../../../styles/Form.module.css"

export default function ParticipantSSN({ field, block, index }) {
  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }

  const isRequired = checkIfRequired()
  const form = useContext(FormContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const [hideField, setHideField] = useState(false)

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const isEditMode = form?.editMode
    const isParticipantProfile = _.endsWith(
      window.location.pathname,
      "profile/"
    )
    const defaultShow = isEditMode || isParticipantProfile
    if (defaultShow) return setHideField(true)
  }, [form])

  const SwitchToogle = () => {
    if (hideField) {
      return <i className="pi pi-eye" onClick={() => setHideField(false)} />
    }
    return <i className="pi pi-eye-slash" onClick={() => setHideField(true)} />
  }

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta, form: formik }) => {
            if (hideField) {
              if (_.isEmpty(formikField.value)) {
                setHideField(false)
              }
              const handleHiddenValue = () => {
                const split = _.split(formikField.value, "-", 3)
                return `###-###-${split[2] || 4}`
              }
              return (
                <span className="p-input-icon-right">
                  <SwitchToogle />
                  <InputText
                    value={handleHiddenValue()}
                    onClick={() => setHideField(false)}
                    disabled={isDisabled}
                    readOnly
                  />
                </span>
              )
            }
            return (
              <>
                <span className="p-input-icon-right">
                  <SwitchToogle />
                  <Input
                    name={formikField.name}
                    value={formikField.value}
                    onChange={formikField.onChange}
                    disabled={isDisabled}
                    onBlur={(e) => {
                      formik.setFieldValue(
                        formikField.name,
                        trimTextValue(e.target.value, TRIM_TYPES.BOTH),
                        true,
                      )
                      formikField.onBlur(e)
                      setHideField(true)
                    }}
                    onComplete={() => setHideField(true)}
                    mask="999-99-9999"
                    placeholder="999-99-9999"
                  />
                </span>
                {meta.touched && meta.error && (
                  <div className={styles.errFieldMsg}>{meta.error}</div>
                )}
              </>
            )
          }}
        </Field>
      </div>
    </div>
  )
}
